import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import ClickOutHandler from 'react-onclickout'

import './styles.scss'
import { useWindowSize } from 'hooks'
import DotsButton from 'components/Buttons/DotsButton'
import { renderMenuTooltip } from './utils'

const MultiMenuTooltip = ({
  toggleButtonComponent,
  dotsOrientation = 'vertical',
  dotsColor = '#6411db',
  options,
  onChangeToggle,
  disabled = false,
  isHide=false,
  topPosition = 30,
  leftPosition = 0,
}) => {
  const toggleBtnRef = useRef(null)
  const [toggleBtnCoords, setToggleBtnCoords] = useState(null)
  const [isOpenTooltip, setIsOpenTooltip] = useState(false)
  const size = useWindowSize()
  const modalPortal = document.getElementById('modal-portal')

  useEffect(() => {
    if(toggleBtnRef?.current) {
      setToggleBtnCoords(toggleBtnRef.current.getBoundingClientRect())
    }
  }, [toggleBtnRef, size, isOpenTooltip])

  const toggleTooltip = () => {
    if (!disabled) {
      setIsOpenTooltip(prevState => !prevState)
      typeof onChangeToggle === 'function' && onChangeToggle(!isOpenTooltip)

      if (!isOpenTooltip) {
        modalPortal.style.display = 'flex'
      } else {
        modalPortal.style.display = 'none'
      }
    }
  }

  return (
    <div className={`
      multi-menu-tooltip
      ${isHide && !isOpenTooltip ? 'multi-menu-tooltip--hide' : ''}
      `}
    >
      <div ref={toggleBtnRef} className='multi-menu-tooltip__toggle-btn-wrapper'>
        {!toggleButtonComponent ? (
          <DotsButton
            orientation={dotsOrientation}
            color={dotsColor}
            onClick={toggleTooltip}
          />
        ) : (
          <button
            className={`
              multi-menu-tooltip__button-component-wrapper
              ${disabled ? 'multi-menu-tooltip__button-component-wrapper--disabled' : ''}
            `}
            onClick={toggleTooltip}
            disabled={disabled}
          >
            {toggleButtonComponent}
          </button>
        )}
      </div>
      {isOpenTooltip ?
        ReactDOM.createPortal(
          <ClickOutHandler onClickOut={toggleTooltip}>
            <div
              className='multi-menu-tooltip__tooltip-container'
              style={{
                top: toggleBtnCoords.y + topPosition,
                left: toggleBtnCoords.x + leftPosition,
              }}
            >
              {renderMenuTooltip(options, toggleTooltip)}
            </div>
          </ClickOutHandler>,
          modalPortal
        ) : null}
    </div>
  )
}

export default MultiMenuTooltip
